const TablePosition = require('./TablePosition')
const moveSelectionBy = require('./transforms/moveSelectionBy')
const insertExitBlockIfNecessary = require('../../../slateUtils/insertExitBlockIfNecessary')

function onUpDown (event, data, state, opts) {
  const direction = data.key === 'up' ? -1 : +1
  const { startBlock } = state
  const pos = TablePosition.create(state, startBlock, opts)
  const table = pos.table

  if ((pos.isLastRow() && direction === +1) || (pos.isFirstRow() && direction === -1)) {
    let transform = insertExitBlockIfNecessary(table, event, data, state)
    if (transform) {
      event.preventDefault()
      return transform.apply()
    }
  } else {
    let transform = moveSelectionBy(opts, state.transform(), 0, direction)
    event.preventDefault()
    return transform.apply()
  }
}

module.exports = onUpDown



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/deep-table-plugin/onUpDown.js